/**
 * @file: useServiceRecordMediaAlbums.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { kNullVIN } from '@euler/functions/constants';
import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { MediaAlbum } from '@euler/model';
import { useServiceFactory } from '@euler/services/factory';
import { useMemo } from 'react';

export const useServiceRecordMediaAlbums = () => {
  const {
    serviceRecord: { _id, licensePlateNo, vin },
  } = useServiceRecordContext();
  const { serviceRecordService } = useServiceFactory();
  const cachePath = useMemo(
    () => `service-records/${_id}/medias/albums.json`,
    [_id],
  );
  return useCachedQuery<MediaAlbum[]>(cachePath, 0, () =>
    vin === kNullVIN
      ? serviceRecordService.getMediaAlbumsByYearMonth({
          licensePlateNo,
          vin,
        })
      : serviceRecordService.getMediaAlbumsByMileage({
          licensePlateNo,
          vin,
        }),
  );
};
